export const URGENCY_MESSAGE_GET_REQUEST = 'URGENCY_MESSAGE_GET_REQUEST';
export const URGENCY_MESSAGE_GET_SUCCESS = 'URGENCY_MESSAGE_GET_SUCCESS';
